<template>
  <div class="xjydshSh">
    <Header title="学籍异动审核" type="1" route="/xjydsh/index"></Header>
    <van-form ref="vanForm" validate-first class="xjydshSh_main">
      <ul class="xjydshSh_main_step">
        <li
          v-for="(item, index) in lcList"
          :key="index"
          :class="{ cur: item.seq <= cur }"
        >
          <div class="shlc-circle">
            <span>{{ index + 1 }}</span>
          </div>
          <span class="shlc-title">
            {{ item.rolename == "" ? "无" : item.rolename }}
          </span>
        </li>
      </ul>
      <van-cell-group class="xjydshSh_main_result">
        <van-field
          label="审核结果"
          input-align="right"
          v-model="form.shjg.text"
          readonly
          required
          :rules="[{ required: true, message: '请选择审核结果' }]"
        />
        <van-radio-group v-model="form.shjg.value">
          <van-radio
            :ref="'vanRadio' + item.value"
            checked-color="#7469F8 "
            :name="item.value"
            :value="item.text"
            v-for="(item, index) in columns.shjg"
            :key="index"
          >
            {{ item.text }}
          </van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group>
        <van-field
          label="异动文号"
          input-align="right"
          v-model="form.ydwh.text"
          placeholder="请输入"
        />
        <van-field
          input-align="right"
          v-model="form.fwrq.text"
          label="发文日期"
          placeholder="请选择"
          right-icon="arrow"
          @click="showDatePop('发文日期', 'fwrq')"
          readonly
        />
        <van-field
          input-align="right"
          v-model="form.sxxq.text"
          label="生效学期"
          placeholder="请选择"
          right-icon="arrow"
          @click="showPop('生效学期', 'sxxq')"
          readonly
          required
          :rules="[{ required: true, message: '请选择生效学期' }]"
        />
        <van-field
          input-align="right"
          v-model="form.bjmc.text"
          label="班级名称"
          placeholder="请选择"
          right-icon="arrow"
          @click="showSearchpPop('班级名称', 'bjmc')"
          readonly
          :required="kzData.bjmc"
          :rules="[{ required: kzData.bjmc, message: '请选择班级名称' }]"
        />
        <template v-if="kzData.time">
          <van-field
            input-align="right"
            v-model="form.xxkssj.text"
            :label="info.title + '开始时间'"
            placeholder="请选择"
            right-icon="arrow"
            @click="showDatePop(info.title + '开始时间', 'xxkssj')"
            readonly
            :required="kzData.xxkz == 1"
            :rules="[
              {
                required: kzData.xxkz == 1,
                message: '请选择' + info.title + '开始时间'
              }
            ]"
          />
          <van-field
            input-align="right"
            v-model="form.xxjssj.text"
            :label="info.title + '结束时间'"
            placeholder="请选择"
            right-icon="arrow"
            @click="showDatePop(info.title + '结束时间', 'xxjssj')"
            readonly
            :required="kzData.xxkz == 1"
            :rules="[
              {
                required: kzData.xxkz == 1,
                message: '请选择' + info.title + '结束时间'
              }
            ]"
          />
        </template>
      </van-cell-group>
      <van-cell-group>
        <template>
          <van-field
            class="qz-textarea"
            v-model="form.shyj.text"
            rows="4"
            autosize
            label="审核意见"
            type="textarea"
            placeholder="请输入"
            @input="val => changeValue(val, 'shyj')"
            :required="kzData.sfbtyj == 1"
            :rules="[
              { required: kzData.sfbtyj == 1, message: '请选择班级名称' }
            ]"
          />
        </template>
      </van-cell-group>
      <div class="xjydshSh_main_lc" v-if="recList.length > 0">
        <mode-rec :recList="recList"></mode-rec>
      </div>
    </van-form>
    <div class="update-button">
      <van-button type="default" @click="cancel">取消</van-button>
      <van-button type="primary" @click="savData">确定</van-button>
    </div>
    <van-popup v-model="showSearch" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="showSearch = false"
        @confirm="
          (value, index) => {
            onConfirmSearch(value, index, valueList.field);
          }
        "
      >
        <template #columns-top>
          <van-search
            v-model="value"
            shape="round"
            background="rgba(116, 105, 248)"
            placeholder="请输入搜索关键词"
          />
        </template>
      </van-picker>
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.title"
        show-toolbar
        :columns="valueList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.field);
          }
        "
      />
    </van-popup>
    <van-popup v-model="showDate" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="valueList.title"
        :min-date="minDate"
        @confirm="
          (value, index) => {
            onConfirmDate(value, index, valueList.field);
          }
        "
      />
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import modeRec from "./mode/modeRec.vue";
export default {
  components: { modeRec },
  data() {
    return {
      recList: [],
      kzData: {},
      cur: "1",
      lcList: [],
      info: {},
      form: {
        ydwh: { text: "", value: "" },
        fwrq: { text: "", value: "" },
        shjg: { text: "", value: "" },
        sxxq: { text: "", value: "" },
        bjmc: { text: "", value: "" },
        xxkssj: { text: "", value: "" },
        xxjssj: { text: "", value: "" },
        shyj: { text: "", value: "" }
      },
      value: "",
      showSearch: false,
      show: false,
      valueList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {},
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      showDate: false
    };
  },
  watch: {
    "form.shjg.value": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.form.shjg.text = this.$refs["vanRadio" + newVal][0].value;
        }
      },
      deep: true
    },
    value: {
      handler(newVal) {
        let column = this.columns[this.valueList.field];
        this.valueList.columns[0].values = column[0].values.filter(
          (item, index) => {
            if (item.text && item.text.indexOf(newVal) != -1) {
              item.defaultIndex = index;
              return true;
            }
            return false;
          }
        );
      },
      deep: true
    }
  },
  created() {
    this.info = this.$route.query;
    this.getList();
  },
  methods: {
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async getList() {
      const params = {
        shType: "xjydsh",
        sh_seq: this.info.ywcode,
        id: this.info.ywinstanceid
      };
      const res = await Api.getshXx(params);
      if (res.code == 1) {
        Object.assign(this.info, res.ydxxInfo);
        if (this.info.fwrq) {
          // 发文日期
          this.form.fwrq.text =
            this.info.fwrq.substr(0, 4) +
            "年" +
            this.info.fwrq.substr(5, 2) +
            "月" +
            this.info.fwrq.substr(8, 2) +
            "日";
          this.form.fwrq.value = this.info.fwrq;
        }
        // 异动文号
        this.form.ydwh.text = this.info.spwh;
        this.form.ydwh.value = this.info.spwh;

        this.lcList = res.lcList;
        this.recList = res.recList;
        this.cur = res.qzwfdefine.seq;

        let defaultIndexSxxq = 0;
        this.columns.sxxq = [
          {
            values: res.xnxqData.map((item, index) => {
              if (item.semesterId === this.info.sxxqid) {
                defaultIndexBjmc = index;
                this.form.sxxq = {
                  text: item.semesterName,
                  value: item.semesterId
                };
              }
              return {
                text: item.semesterName,
                value: item.semesterId
              };
            }),
            defaultIndex: defaultIndexSxxq
          }
        ];
        let defaultIndexBjmc = 0;
        this.columns.bjmc = [
          {
            values: res.bjData.map((item, index) => {
              if (item.bjid === this.info.newbjid) {
                defaultIndexBjmc = index;
                this.form.bjmc = {
                  text: item.bjname,
                  value: item.bjid
                };
              }
              return {
                text: item.bjname,
                value: item.bjid
              };
            }),
            defaultIndex: defaultIndexBjmc
          }
        ];

        this.kzData = res.qzwfdefine;
        this.kzData.time = this.info.ydlbm == "11" || this.info.ydlbm == "18";
        if (
          this.info.ydlbm == "02" ||
          this.info.ydlbm == "12" ||
          this.info.ydlbm == "23"
        ) {
          this.kzData.bjmc = true;
        } else if (this.kzData.zsbz == "1" && this.kzData.clxsbj == "1") {
          this.kzData.bjmc = true;
        }
        if (this.info.ydlbm == "11") {
          this.info.title = "休学";
          if (this.info.xxksrq) {
            // 休学开始时间
            this.form.xxkssj.text =
              this.info.xxksrq.substr(0, 4) +
              "年" +
              this.info.xxksrq.substr(5, 2) +
              "月" +
              this.info.xxksrq.substr(8, 2) +
              "日";
            this.form.xxkssj.value = this.info.xxksrq;
            // 休学结束时间
            this.form.xxjssj.text =
              this.info.xxjsrq.substr(0, 4) +
              "年" +
              this.info.xxjsrq.substr(5, 2) +
              "月" +
              this.info.xxjsrq.substr(8, 2) +
              "日";
            this.form.xxjssj.value = this.info.xxjsrq;
          }
        } else if (this.info.ydlbm == "18") {
          this.info.title = "保留学籍";
          if (this.info.blksrq) {
            // 保留学籍开始时间
            this.form.xxkssj.text =
              this.info.blksrq.substr(0, 4) +
              "年" +
              this.info.blksrq.substr(5, 2) +
              "月" +
              this.info.blksrq.substr(8, 2) +
              "日";
            this.form.xxkssj.value = this.info.blksrq;
            // 保留学籍结束时间
            this.form.xxjssj.text =
              this.info.bljsrq.substr(0, 4) +
              "年" +
              this.info.bljsrq.substr(5, 2) +
              "月" +
              this.info.bljsrq.substr(8, 2) +
              "日";
            this.form.xxjssj.value = this.info.bljsrq;
          }
        }
        if (this.kzData.isend == "1") {
          this.columns.shjg = [
            { text: "通过", value: "1" },
            { text: "不通过", value: "0" },
            { text: "终止流程", value: "2" }
          ];
        } else {
          this.columns.shjg = [
            { text: "通过", value: "1" },
            { text: "不通过", value: "0" }
          ];
        }
      }
    },
    cancel() {
      this.$router.replace("/xjydsh/detail");
    },
    savData() {
      this.$refs.vanForm.validate().then(
        async () => {
          if (
            this.kzData.time &&
            this.kzData.xxkz == 1 &&
            Number(this.form.xxkssj.value) >= Number(this.form.xxjssj.value)
          ) {
            this.$toast.fail("结束日期要在起始日期之后！");
            return;
          }

          let params = {
            sh_type: "xjydsh",
            // 业务id
            id: this.info.ywinstanceid,
            // examine/getXjydShList中返回的ywcode字段，该字段需传到审核页面
            code: this.info.ywcode,
            // 生效学期
            sxxqid: this.form.sxxq.value,
            // 休学开始时间
            kssj: this.form.xxkssj.value,
            // 休学结束时间
            jssj: this.form.xxjssj.value,
            // 异动后班级id
            newbjid: this.form.bjmc.value,
            // 异动文号
            spwh: this.form.ydwh.value,
            // 发文日期
            fwrq: this.form.fwrq.value,
            // 审核意见
            shyj: this.form.shyj.value,
            // 审核结果
            type: this.form.shjg.value
          };

          const res = await Api.workflowAuditing(params);
          if (res.code == 1) {
            this.$toast.success("学籍异动审核已提交！");
            setTimeout(() => {
              this.$router.replace("/xjydsh/index");
            }, 1500);
          }
        },
        () => {}
      );
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    },
    // 弹出搜索选择器
    showSearchpPop(title, field) {
      this.showSearch = true;
      this.valueList.title = title;
      this.valueList.field = field;
      this.valueList.columns = JSON.parse(JSON.stringify(this.columns[field]));
    },
    // 搜索选择确认
    onConfirmSearch(value, index, field) {
      this.showSearch = false;
      this.form[field] = value[0];
      if (value[0].defaultIndex) {
        this.columns[this.valueList.field][0].defaultIndex =
          value[0].defaultIndex;
      }
      //   this.getList();
    },
    showDatePop(title, field, flag) {
      if (this.form[field].value) {
        let yy = this.form[field].value.substr(0, 4);
        let mm = this.form[field].value.substr(5, 2);
        let dd = this.form[field].value.substr(8, 2);
        this.currentDate = new Date(yy, mm - 1, dd);
      } else {
        this.currentDate = new Date();
      }

      this.showDate = true;
      this.valueList.title = title;
      this.valueList.field = field;
    },
    onConfirmDate(date, index, field) {
      this.showDate = false;
      let yy = date.getFullYear();
      let mm =
        Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1;
      let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.form[field].text = yy + "年" + mm + "月" + dd + "日";
      this.form[field].value = yy + "-" + mm + "-" + dd;
    }
  }
};
</script>
<style lang="less" scoped>
.xjydshSh {
  height: 100%;
  background-color: #f2f2f4;
  .xjydshSh_main {
    overflow: auto;
    height: calc(~"100% - 70px");
    .xjydshSh_main_step {
      padding: 9px 14px;
      background-image: linear-gradient(96deg, #8076ff 0%, #7469f8 100%);
      box-shadow: 0px 3px 6px 0px rgba(116, 105, 248, 0.2);
      margin-bottom: 8px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      box-sizing: border-box;

      li {
        position: relative;
        display: flex;
        align-items: center;
        line-height: 22px;
        padding: 9px 0;
        .shlc-circle {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #7469f8;
          letter-spacing: 0;
          font-weight: bolder;

          width: 18px;
          height: 18px;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 50%;
          margin-right: 4px;
        }
        .shlc-title {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.4);
          letter-spacing: 0;
          text-align: center;
        }
        &.cur {
          &::before {
            border: 1px solid rgba(255, 255, 255, 0.6);
          }
          .shlc-circle {
            background-color: #fff;
            &::before {
              position: absolute;
              content: "";
              width: 22px;
              height: 22px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.2);
            }
          }
          .shlc-title {
            color: #fff;
          }
        }
        & + li {
          margin-left: 32px;
          &::before {
            position: absolute;
            content: "";
            width: 20px;
            border: 1px dashed rgba(255, 255, 255, 0.4);
            right: calc(~"100% + 6px");
            top: 50%;
            transform: translate(0, -50%);
          }
        }
      }
    }

    /deep/.van-cell-group {
      margin-bottom: 8px;
      .van-cell {
        padding: 14px 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        letter-spacing: 0;
        font-weight: 400;
        &::after {
          left: 15px;
          right: 15px;
          border-bottom: 1px solid #e5e5e5;
        }
        .van-field__label {
          width: fit-content;
          span {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 400;
            white-space: nowrap;
          }
        }
        .van-field__error-message {
          text-align: right;
        }
        .van-field__control::placeholder {
          color: #b2b2b2 !important;
        }
        .van-field__right-icon {
          .van-icon {
            color: #b2b2b2;
          }
        }
        .van-field__word-limit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #b2b2b2;
          letter-spacing: 0.3px;
          font-weight: 400;
        }
        &.qz-textarea {
          flex-direction: column;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          letter-spacing: 0.3px;
          font-weight: 400;
          .van-field__control::placeholder {
            color: #b2b2b2 !important;
          }
        }
      }
    }
    /deep/.xjydshSh_main_result {
      .van-cell::after {
        left: 0;
        right: 0;
      }
    }
    /deep/.van-radio-group {
      padding: 18px 15px;
      .van-radio {
        & + .van-radio {
          margin-top: 18px;
        }
        .van-radio__label {
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 22px;
        }
      }
    }
    .xjydshSh_main_lc {
      padding: 0 15px 12px;
    }
  }
  .update-button {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 70px;
    background: #ffffff;
    padding: 10px 15px;
    border-top: 1px solid #e5e5e5;
    .van-button {
      height: 100%;
      width: calc(~"50% - 7.5px");
      border: 1px solid #e5e5e5;
      border-radius: 25px !important;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .van-button--normal {
      color: #666666;
    }
    .van-button--primary {
      color: #ffffff;
      background-color: #7469f8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/sh.vue